import { createSlice } from '@reduxjs/toolkit';
import { setDoneOrdersFilters } from '../../actions/orders/doneOrdersActions';

const initialState = {
  data: [],
  pagination: {},
  isLoading: false,
  hasMore: false,
  filters: {
    doneOrders: {},
  },
};

const doneOrdersReducer = createSlice({
  name: 'doneOrders',
  initialState,
  extraReducers: {
    [setDoneOrdersFilters.type]: (state, { payload }) => {
      state.filters.doneOrders[payload.companyId] = payload.filters;
    },
  },
});

export default doneOrdersReducer;
